module.exports = __webpack_public_path__ + "img/cjsh.72b03439.png";